import {Component, Inject, OnInit} from "@angular/core";
import {Visitor} from "../visitor/visitor";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: "app-unregister-dialog",
  templateUrl: "./unregister-dialog.component.html",
  styleUrls: ["./unregister-dialog.component.css"]
})
export class UnregisterDialogComponent {

  onClose(result: boolean): void {
    this.dialogRef.close(result);
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: Visitor, private dialogRef: MatDialogRef<UnregisterDialogComponent>) {
  }

}
